import { combineReducers } from 'redux';
import KpiModuleReducer from './KpiModuleReducer';
const kpiReducer = combineReducers({
    KpiModuleReducer,
});
  
  
export default kpiReducer;